import React, { Component, ErrorInfo, ReactNode } from 'react';
import MaintenancePage from '../pages/MaintenancePage';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <MaintenancePage />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
